import { IBaseResponse } from '@/@types/ResponseModel';
import config from '@/config';
import axiosApi from '@/core/interceptor/interceptor';
import axios from 'axios';

export function getPresignedUploadUrl(
  key: string
): Promise<IBaseResponse<any>> {
  try {
    return axios.post(`${config.apiUrl}auth/presigned-upload-url/`, {
      key,
    });
  } catch (error) {
    return Promise.reject(error);
  }
}

export function uploadFileToPresignedUrl(
  url: string,
  file: File
): Promise<IBaseResponse<any>> {
  try {
    return axios.put(url, file, {
      headers: {
        'Content-Type': file.type,
      },
    });
  } catch (error) {
    return Promise.reject(error);
  }
}

export function memberSignup(body: any): Promise<IBaseResponse<any>> {
  try {
    return axiosApi.post(`${config.apiUrl}auth/member`, body);
  } catch (error) {
    return Promise.reject(error);
  }
}

export function checkMemberDuplicateEmail(email: string) {
  try {
    return axios.post(`${config.apiUrl}auth/check-duplicate-email`, {
      email,
    });
  } catch (error) {
    return Promise.reject(error);
  }
}

export function checkDuplicateMembershipId(club_membership_id: string) {
  try {
    return axios.post(`${config.apiUrl}auth/check-duplicate-membershipId`, {
      club_membership_id,
    });
  } catch (error) {
    return Promise.reject(error);
  }
}

export function checkSubMemberDuplicateEmail(email: string, id?: number) {
  try {
    return axios.post(`${config.apiUrl}auth/check-sub-member-duplicate-email`, {
      email,
      id,
    });
  } catch (error) {
    return Promise.reject(error);
  }
}
